var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel',{attrs:{"pagination-color":"#6f707b","pagination-active-color":"#3139f2","scroll-per-page":true,"per-page-custom":[
    [240, 1],
    [640, 2],
    [1200, 3]
  ]}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }